var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { AppState } from "@/share/AppState";
import { ObjectUpdateType } from "@/share/models";
import { ALLViewer, AnnotationType, NoteType } from "@@/Annotation";
import { DateLib } from "@@/Datelib";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { convertDepToRows, parser, decryptCell as GDecryptcell, canShowRemoteEntry } from "@@/RuleParser";
import { SchemaItemType } from "@@/Schema";
import { isIpadScreen, stripHTML, testIsMobile, timeout } from "@@/Util";
import { action, makeObservable, observable } from "mobx";
import { ColorStore } from "@/app/UIComponents/ColorDialog";
import { CommentState } from "@/app/UIComponents/Comments";
import { FileUploadDialogState } from "@/app/UIComponents/FileUploadDialog";
import { SelectMemberDialogState } from "@/app/UIComponents/SelectMemberDialog";
import { AccessGroupState } from "@/app/uistore/AccessgroupState";
import { DraftNoteUI } from "@/app/uistore/DraftNoteUI";
import { FilterDialogState } from "@/app/UIComponents/FilterDialogState";
export class AdminFloatingDatasheetStore {
    constructor() {
        this.width = testIsMobile() || isIpadScreen() ? window.innerWidth - 50 : window.innerWidth / 2;
        this.left = isIpadScreen() ? 20 : 100;
        this.top = 100;
        this.dragging = false;
        this.title = "";
        this.show = false;
        this.linkingmode = false;
        this.size = 0;
        this.schemas = new Map();
        this.sortedschemaitems = [];
        this.activelterid = "";
        this.loading = false;
        this.activeschema = "";
        this.loadingcontent = false;
        this.showform = false;
        this.storingform = false;
        this.reqdid = "";
        this.reqsid = "";
        this.reqrowid = "";
        this.formentry = new Map();
        // @observable public rowsMap: SchemaRow[] = [];
        this.rowsMap = new Map();
        this.newrowsmap = [];
        this.buildingview = false;
        this.showlinkdialog = false;
        this.showactiveviewmenu = false;
        this.activeview = "grid";
        this.commentstate = new CommentState();
        this.smstate = new SelectMemberDialogState();
        this.lastcommenttime = -1;
        this.showstatuesmenu = false;
        this.loadmore = false;
        this.activecardsttaus = "";
        this.activecardgroupby = "";
        this.activecardstatusname = "";
        this.activecardgroupname = "";
        this.startnotes = false;
        this.showgroupbymenu = false;
        this.showganttstartdate = false;
        this.showganttstartdatename = "Task Start Date";
        this.showganttenddatename = "Task End Date";
        this.colorfieldname = "Default Colors";
        this.colorfieldid = "";
        this.showcolorfield = false;
        this.showchartmenu = false;
        this.links = [];
        this.selectedrows = new Map();
        this.schemanotesloading = false;
        this.accessstorestate = new AccessGroupState();
        this.activeloadednotesref = "";
        this.deletenoteids = new Set();
        this.shownotespanel = !isIpadScreen() ? true : false;
        this.sindex = 0;
        this.descfieldname = "";
        this.descfieldid = "";
        this.showdescfield = false;
        this.activedetailtab = "detail";
        this.loadingcomments = false;
        this.deletingnote = false;
        this.enableannotation = true;
        this.showfilter = false;
        this.showbookmarklinkdetail = new Set();
        this.colorstate = new ColorStore();
        this.lastnotesupdatetime = -1;
        this.notesbyid = new Map();
        this.activeaccessids = new Set([ALLViewer]);
        this.appliedaclstr = "---";
        this.editnoteid = "";
        this.editmode = false;
        this.showcomments = false;
        this.loadingnotes = false;
        this.authors = new Map();
        this.activerequestid = "";
        this.showganttenddate = false;
        this.ganttstartid = "";
        this.ganttendid = "";
        this.ganttasknameid = "";
        this.ganttasknamefieldname = "";
        this.activerowid = "";
        this.savingrow = false;
        this.savingnote = false;
        this.editrowproperty = new Map();
        this.activerowindex = -1;
        this.notelinksdialogleft = 0;
        this.notelinksdialogtop = 70;
        this.colors = ['#fec1ce', '#d7f3f2', '#cbd8f9'];
        this.activebuilingid = -1;
        this.showinoutlinks = new Set();
        this.activedatasheet = "";
        this.fileuploadstate = new FileUploadDialogState();
        this.activereqid = "";
        this.objectviewer = false;
        this.checkingandcollecting = false;
        this.rowRules = new Map();
        this.depschemarows = new Map();
        this.depschema = new Map();
        this.fetchingdepend = false;
        this.schemasmap = new Map();
        this.waitingentries = [];
        this.parsingentry = new Set();
        this.gettinganas = false;
        this.anas = new Map();
        this.anasschema = new Map();
        this.colwithschemarules = new Set();
        this.dependentdata = new Map();
        this.activeuserid = "";
        this.rowsarrids = [];
        this.loadedentry = 0;
        this.hiddenrows = new Set();
        this.showrowsilter = false;
        this.showcolumnview = false;
        this.hiddencolumns = new Set();
        this.filterdialogstate = new FilterDialogState();
        makeObservable(this);
        APPEvent.addSubscriberForAppState((st) => {
            if (st === AppState.LoggedIn) {
                this.reset();
            }
        });
        // APPEvent.addSubscriberForUpdateEntry((data) => {
        //     if (data.sid === this.activeschema && data.row !== undefined) {
        //         this.updateRow(data.rowid ?? '', data.row.entry);
        //         this.setSavingRow(false);
        //     }
        // });
        APPEvent.addSubscriberForAdminLetrChanged((letr) => {
            if (this.activelterid !== letr.id) {
                this.activelterid = letr.id;
                this.reset();
            }
        });
        APPEvent.addSubscriberForLetrUserChanged((useird) => {
            this.activeuserid = useird;
        });
        APPEvent.addSubscriberForAdminGetSchema((schs) => {
            if (!schs.floating || schs.userid !== this.activeuserid) {
                return;
            }
            let set = "";
            for (const sch of schs.schema) {
                if (sch.letrid === this.activelterid) {
                    this.addSchema(sch);
                    if (this.activeschema === sch.id || this.reqsid === sch.id) {
                        set = sch.id;
                    }
                }
            }
            if (!set && this.schemas.size > 0) {
                set = Array.from(this.schemas.values()).sort((sh1, sh2) => sh1.name.toLowerCase().localeCompare(sh2.name.toLowerCase()))[0].id;
            }
            this.reqsid = "";
            if (set) {
                this.setActiveSchema(set);
            }
            this.setLoading(false);
        });
        APPEvent.addSubscriberForAdminDependResp(async (res) => {
            var _a;
            if (!res.floating && res.schemaid === this.activeschema && res.userid === this.activeuserid) {
                // awesome!!
                // lets store this now
                this.schemadep = res;
                // lets build data for columns now!!
                const mapofdata = new Map();
                if (res.depn) {
                    for (const en of res.depn) {
                        if (!mapofdata.has(en.id)) {
                            mapofdata.set(en.id, []);
                        }
                        (_a = mapofdata.get(en.id)) === null || _a === void 0 ? void 0 : _a.push(...en.entries);
                    }
                }
                // we should create some missing columns that we might need!!
                // there might be rule 
                this.depschemarows = convertDepToRows(mapofdata);
                if (res.schemas) {
                    for (const shh of res.schemas) {
                        this.schemasmap.set(shh.id, shh);
                    }
                }
                this.depschemarows.set(this.activeschema, Array.from(this.rowsMap.values()));
                this.setFeatchingDepende(false);
                for (const en of this.waitingentries) {
                    // lets do these first and then we will be fine!
                    this.parseCellRule(en);
                }
                this.waitingentries = [];
                // also build the rule for one that are done!!
            }
        });
        APPEvent.addSubscriberForAdminPartialRows(async (rows) => {
            var _a;
            if (!rows.floating || rows.schemaid !== this.activeschema || rows.userid !== this.activeuserid) {
                return;
            }
            if (rows.rows.length > 0) {
                await this.addRowInline(rows.rows, false);
                //await this.addToTemp(rows.rows);
                this.setLoadedRows(this.rowsMap.size);
            }
            if (rows.islast) {
                if (rows.rules) {
                    for (const rr of rows.rules) {
                        this.addRowRule(rr);
                    }
                }
                if (rows.deps) {
                    this.decryptAndSetupDepRemoteItems(rows.deps, (_a = rows.depsdep) !== null && _a !== void 0 ? _a : []);
                }
                await this.addRuleEntryToRows();
                // we have new rules now
                this.collectRowsAndBuildRulesResult();
                await this.buildRowsArray();
                this.setLoadingContent(false);
            }
        });
    }
    setLoadedRows(count) {
        this.loadedentry = count;
    }
    async addRowInline(row, clear = true) {
        if (clear) {
            this.rowsMap.clear();
            this.rowsarrids.splice(0, this.rowsarrids.length);
        }
        let index = 0;
        for (const r of row) {
            this.rowsMap.set(r.rowid, r);
            if (index > 0 && index % 1000 == 0) {
                await timeout(100);
            }
            ;
            index++;
        }
        await timeout(10);
    }
    async buildRowsArray() {
        const arr = [];
        let i = 0;
        for (const row of this.rowsMap) {
            arr.push(row[1]);
            if (i > 0 && i % 5000 == 0)
                await timeout(50);
            i++;
        }
        this.rowsarrids = arr;
        await timeout(50);
    }
    decryptAndSetupDepRemoteItems(dep, darr) {
        var _a;
        const sh = this.schemas.get(this.activeschema);
        if (!sh)
            return;
        const mapofdpsh = new Map();
        dep.data.forEach((dt) => {
            mapofdpsh.set(dt.schema.id, dt);
        });
        const mapofdata = new Map();
        const mapofschema = new Map();
        let doneenid = new Set();
        dep.data.forEach((dt) => {
            var _a;
            if (dt.schemaopen) {
                mapofschema.set(dt.schema.id, dt.schemaopen);
            }
            for (const en of dt.entries) {
                if (!doneenid.has(en.id)) {
                    if (!mapofdata.has(dt.schema.datasheetid + "~~~" + dt.schema.id + "~~~" + en.cellid)) {
                        mapofdata.set(dt.schema.datasheetid + "~~~" + dt.schema.id + "~~~" + en.cellid, []);
                    }
                    (_a = mapofdata.get(dt.schema.datasheetid + "~~~" + dt.schema.id + "~~~" + en.cellid)) === null || _a === void 0 ? void 0 : _a.push(en);
                    doneenid.add(en.id);
                }
            }
        });
        for (const en of darr) {
            if (!mapofdata.has(en.id)) {
                mapofdata.set(en.id, []);
            }
            for (const e of en.entries) {
                if (!doneenid.has(e.id)) {
                    (_a = mapofdata.get(en.id)) === null || _a === void 0 ? void 0 : _a.push(e);
                    doneenid.add(e.id);
                }
            }
        }
        // we should create some missing columns that we might need!!
        // there might be rule 
        const depschemarows = convertDepToRows(mapofdata);
        let ritems = [];
        for (const it of sh.items) {
            if (it.type === SchemaItemType.Remote) {
                ritems.push(it);
            }
            else if (it.type === SchemaItemType.List) {
                const lit = it;
                if (lit.items) {
                    for (const li of lit.items) {
                        if (li.item.type === SchemaItemType.Remote) {
                            ritems.push(li.item);
                        }
                    }
                }
            }
        }
        ritems.forEach((it) => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (it.type === SchemaItemType.Remote) {
                const srit = it;
                if (srit.did && srit.sid && srit.cid) {
                    const dp = mapofdpsh.get(srit.sid);
                    if (dp !== undefined && dp.schemaopen !== undefined) {
                        const items = (_a = dp.schemaopen.items) !== null && _a !== void 0 ? _a : [];
                        let ischoice = false;
                        for (const item of items) {
                            if (item.id === srit.cid) {
                                // found it 
                                if (item.type === SchemaItemType.Choice) {
                                    // ohh all we need here is choice
                                    ischoice = true;
                                    const id = srit.id + "---" + srit.sid + "---" + srit.cid;
                                    this.dependentdata.set(id, []);
                                    item.items.forEach((it) => {
                                        var _a;
                                        return (_a = this.dependentdata.get(id)) === null || _a === void 0 ? void 0 : _a.push({
                                            id: it.id,
                                            value: it.name
                                        });
                                    });
                                }
                                else {
                                    // not an choice 
                                    // we need to check conditions and parse the rules here!
                                    const enmap = new Map();
                                    for (const en of dp.entries) {
                                        if (!enmap.has(en.cellid)) {
                                            enmap.set(en.cellid, []);
                                        }
                                        (_b = enmap.get(en.cellid)) === null || _b === void 0 ? void 0 : _b.push(en);
                                    }
                                    if (srit.conds && srit.conds.length > 0) {
                                        // lets chekc if any rules apply to my entries we can open them up!
                                        for (const con of srit.conds) {
                                            for (const cp of con.params) {
                                                // now we have this 
                                                if (cp.leftcond) {
                                                    const ens = enmap.get(cp.leftcond);
                                                    if (ens) {
                                                        for (const e of ens) {
                                                            if (e.ruleopen) {
                                                                parser([e], dp.schemaopen, depschemarows, mapofschema);
                                                            }
                                                            else if (!e.decrypted) {
                                                                GDecryptcell(e, dp.schemaopen);
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    const id = srit.id + "---" + srit.sid + "---" + srit.cid;
                                    this.dependentdata.set(id, []);
                                    const entries = dp.entries;
                                    for (const en of entries) {
                                        if (!en.decrypted) {
                                            GDecryptcell(en, dp.schemaopen);
                                        }
                                        if (en.cellid !== item.id)
                                            continue;
                                        // now we can do some clever filtering and we done!!
                                        let cons = srit.conds;
                                        if (cons && cons.length > 0) {
                                            // cons = filterInvalidConsitions(cons);
                                        }
                                        if (cons && cons.length > 0) {
                                            const rows = depschemarows.get(srit.sid);
                                            if (!rows)
                                                continue;
                                            const myens = [];
                                            const rind = en.rowid;
                                            for (const r of rows) {
                                                if (r.rowid === rind) {
                                                    for (const e1 of r.entry) {
                                                        myens.push(e1);
                                                    }
                                                }
                                            }
                                            if (!canShowRemoteEntry(en, cons, myens)) {
                                                continue;
                                            }
                                        }
                                        if (item.type === SchemaItemType.Text) {
                                            (_c = this.dependentdata.get(id)) === null || _c === void 0 ? void 0 : _c.push({
                                                id: en.id,
                                                value: (_d = stripHTML(en.celldata)) !== null && _d !== void 0 ? _d : ''
                                            });
                                        }
                                        else if (item.type === SchemaItemType.Date) {
                                            (_e = this.dependentdata.get(id)) === null || _e === void 0 ? void 0 : _e.push({
                                                id: en.id,
                                                value: DateLib.displayDateWIthFormat(en.celldata, item.inlcudetime, (_f = item.excludedate) !== null && _f !== void 0 ? _f : false)
                                            });
                                        }
                                        else {
                                            (_g = this.dependentdata.get(id)) === null || _g === void 0 ? void 0 : _g.push({
                                                id: en.id,
                                                value: en.celldata
                                            });
                                        }
                                    }
                                }
                                break;
                            }
                        }
                    }
                }
            }
        });
    }
    clearAns() {
        this.anas.clear();
        this.anasschema.clear();
    }
    setGettingAns(gett) {
        this.gettinganas = gett;
    }
    getAnalytics() {
        this.setGettingAns(true);
        const req = {
            letrid: this.activelterid,
            floating: true,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("adminschemaanalytics", req);
    }
    getRows() {
        return Array.from(this.rowsMap.values()).sort((r1, r2) => r1.rowindex - r2.rowindex);
    }
    parseCellRule(fitem) {
        var _a;
        if (!this.activeschema) {
            return;
        }
        if (this.parsingentry.has(fitem.id) || fitem.decrypted) {
            return;
        }
        // we should now add this entry in the parsing stuff
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return;
        }
        this.parsingentry.add(fitem.id);
        if (fitem.ruleopen) {
            const wen = Object.assign({}, fitem);
            // lets now rebuild this rule now
            if (!this.depschemarows.has(this.activeschema) ||
                ((_a = this.depschemarows.get(this.activeschema)) === null || _a === void 0 ? void 0 : _a.length) !== this.rowsMap.size) {
                this.depschemarows.set(this.activeschema, Array.from(this.rowsMap.values()));
            }
            if (!this.schemasmap.has(this.activeschema)) {
                this.schemasmap.set(this.activeschema, achema);
            }
            parser([wen], achema, this.depschemarows, this.schemasmap);
            // now we have this cell done we just need to remove this cell from the 
            fitem.celldata = wen.celldata;
            fitem.decrypted = true;
        }
        this.removeIdfromParsing(fitem.id);
    }
    removeIdfromParsing(id) {
        this.parsingentry.delete(id);
    }
    collectRowsAndBuildRulesResult() {
        const req = this.schemas.get(this.activeschema);
        if (!req)
            return;
        // lets do this now
        let entries = [];
        // lets check the rules first 
        let solid = new Set();
        let haverules = false;
        if (req.rules) {
            for (const cr of req.rules) {
                for (const pr of cr.rule) {
                    let breakit = false;
                    for (const rrv of pr.params) {
                        if (rrv.type !== 'schema')
                            continue;
                        if (rrv.value && rrv.value.split("~~~").length > 2) {
                            const parts = rrv.value.split("~~~");
                            if ((parts[0] !== req.datasheetid || parts[1] !== req.id)) {
                                if (this.depschemarows.has(parts[1])) {
                                    // lets check if the row has the column
                                    const cid = parts[2];
                                    const sh = this.depschemarows.get(parts[1]);
                                    if (sh && sh.length > 0) {
                                        const r1 = sh[0];
                                        let had = false;
                                        for (const re of r1.entry) {
                                            if (re.cellid === cid) {
                                                had = true;
                                                break;
                                            }
                                        }
                                        if (had)
                                            continue;
                                    }
                                }
                                haverules = true;
                                breakit = true;
                                break;
                            }
                        }
                    }
                    if (breakit) {
                        break;
                    }
                }
            }
        }
        if (this.rowRules.size > 0 && !haverules) {
            for (const r of this.rowRules.values()) {
                for (const cr of r.data) {
                    for (const pr of cr.rule) {
                        let breakit = false;
                        for (const rrv of pr.params) {
                            if (rrv.type !== 'schema')
                                continue;
                            if (rrv.value && rrv.value.split("~~~").length > 2) {
                                const parts = rrv.value.split("~~~");
                                if (parts[0] !== req.datasheetid || parts[1] !== req.id) {
                                    if (this.depschemarows.has(parts[1])) {
                                        // lets check if the row has the column
                                        const cid = parts[2];
                                        const sh = this.depschemarows.get(parts[1]);
                                        if (sh && sh.length > 0) {
                                            const r1 = sh[0];
                                            let had = false;
                                            for (const re of r1.entry) {
                                                if (re.cellid === cid) {
                                                    had = true;
                                                    break;
                                                }
                                            }
                                            if (had)
                                                continue;
                                        }
                                    }
                                    haverules = true;
                                    breakit = true;
                                    break;
                                }
                            }
                        }
                        if (breakit) {
                            break;
                        }
                    }
                }
            }
        }
        for (const row of this.rowsMap.values()) {
            entries.push(...row.entry);
        }
        // now we have the all the entries that need something to be done!1
        if (haverules) {
            this.setFeatchingDepende(true);
            // lets get dependnt and we done then 
            const req1 = {
                letrid: this.activelterid,
                schemaid: this.activeschema,
                sh: req,
                en: entries,
                rules: Array.from(this.rowRules.values()),
                userid: this.activeuserid,
                floating: true
            };
            // this is coole stuff now!!
            Apphandler.sendMessage("admindependententries", req1);
        }
        else {
            this.depschemarows.set(this.activeschema, Array.from(this.rowsMap.values()));
        }
        this.setCollectingData(false);
    }
    setFeatchingDepende(fetch) {
        this.fetchingdepend = fetch;
    }
    setCollectingData(col) {
        this.checkingandcollecting = col;
    }
    setObjectViewerMode(mode) {
        this.objectviewer = mode;
    }
    setGanttTaskField(id) {
        this.ganttasknameid = id;
    }
    setGanttTaskFieldName(name) {
        this.ganttasknamefieldname = name;
    }
    setSavingRow(saving) {
        this.savingrow = saving;
    }
    addRowSel(sel) {
        this.selectedrows.set(sel.rowid, sel);
    }
    setLinkingMode(mode) {
        this.linkingmode = mode;
    }
    removeRowSel(sel) {
        this.selectedrows.delete(sel);
    }
    clearRowsel() {
        this.selectedrows.clear();
    }
    saveComment(com) {
        var _a;
        if (this.editmode && this.editnoteid) {
            const savereq = {
                letrid: this.activelterid,
                objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
                replaceid: com.id,
                text: (_a = com.datastr) !== null && _a !== void 0 ? _a : "",
                noteid: this.editnoteid
            };
            Apphandler.sendMessage("addcomment", savereq);
        }
    }
    setAuthor(n) {
        this.authors.set(n.authorid, {
            authorid: n.authorid,
            authorname: n.authorname
        });
    }
    removeDeletingNote(dn) {
        this.deletenoteids.delete(dn);
    }
    setDragging(dragging) {
        this.dragging = dragging;
    }
    setLeft(left) {
        this.left = left;
    }
    setTop(top) {
        this.top = top;
    }
    setWidth(width) {
        this.width = width;
    }
    removeShowBookmarkDetail(id) {
        this.showbookmarklinkdetail.delete(id);
    }
    setShowBookmark(id) {
        this.showbookmarklinkdetail.add(id);
    }
    clearShowBookmark() {
        this.showbookmarklinkdetail.clear();
    }
    resetFilter() {
        this.notesbyid.forEach((n, k) => {
            if (n.note !== undefined) {
                n.setVisible(true);
            }
        });
    }
    setEnableAnnotation(enable) {
        this.enableannotation = enable;
    }
    deleteLink(link) {
        const id = this.links.indexOf(link);
        if (id !== undefined && id > -1) {
            this.links.splice(id, 1);
        }
    }
    setNoteLinksDialogLeft(left) {
        this.notelinksdialogleft = left;
    }
    setNoteLinksDialogTop(top) {
        this.notelinksdialogtop = top;
    }
    setShowDialog(show) {
        this.show = show;
    }
    setShowLinksForNote(noteid) {
        this.showinoutlinks.add(noteid);
    }
    clearShowLinksForNote() {
        this.showinoutlinks.clear();
    }
    removeShowLinksForNote(noteid) {
        this.showinoutlinks.delete(noteid);
    }
    setLoadingNotes(loading) {
        this.loadingnotes = loading;
    }
    setShowNotesPanel(show) {
        this.shownotespanel = show;
    }
    addNote(note) {
        this.notesbyid.set(note.id, this.convertNoteToNoteUI(note));
    }
    setDeletingNote(dn) {
        this.deletenoteids.add(dn);
    }
    loadComments() {
        if (this.loadingcomments || !this.editnoteid) {
            return;
        }
        this.setLoadingComments(true);
        const getcoom = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            noteid: this.editnoteid
        };
        Apphandler.sendMessage("getcomments", getcoom);
    }
    setEditMode(mode) {
        this.editmode = mode;
        if (!mode) {
            this.activeaccessids = new Set([ALLViewer]);
            this.appliedaclstr = "---";
        }
    }
    deleteComment(id) {
        const req = {
            letrid: this.activelterid,
            objectid: this.editnoteid,
            id: id
        };
        Apphandler.sendMessage("deletecomment", req);
    }
    setShowFilter(show) {
        this.showfilter = show;
    }
    saveNote() {
        var _a;
        const marking = "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid;
        const databox = {
            detail: [{ key: 'systemtext', value: '' }],
            notetype: AnnotationType.Freehand,
            boxes: [],
            match: marking,
            color: (_a = this.colorstate.color) !== null && _a !== void 0 ? _a : 'lightgray',
            storekthickness: -1
        };
        const note = {
            id: "",
            data: databox,
            type: NoteType.Note,
            viewer: Array.from(this.activeaccessids),
            parentid: "",
            authorname: "",
            authorid: "",
            updatetime: 0,
            replycount: 0,
            aclstr: "---",
            notereference: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid
        };
        this.activerequestid = Math.random() + "";
        if (this.links.length > 0) {
            note.linkboxes = this.links;
        }
        const req = {
            reqid: this.activerequestid,
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            note: note,
            comment: this.commentstate.getComments()
        };
        Apphandler.sendMessage("savenote", req);
        this.setSavingNote(true);
    }
    saveEdit() {
        if (this.editmode && this.editnoteid) {
            // lets get the new two filed and that's all
            const uinote = this.notesbyid.get(this.editnoteid);
            if (uinote !== undefined) {
                const enote = uinote.note;
                enote.aclstr = this.appliedaclstr;
                enote.viewer = Array.from(this.activeaccessids);
                enote.data.detail = [{ key: 'systemtext', value: '' }];
                this.setSavingNote(true);
                this.activerequestid = enote.id;
                const req = {
                    reqid: this.activerequestid,
                    letrid: this.activelterid,
                    objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
                    note: enote,
                    comment: []
                };
                Apphandler.sendMessage("updatenote", req);
            }
        }
    }
    setSavingNote(saving) {
        this.savingnote = saving;
    }
    setEditNoteId(id) {
        this.editnoteid = id;
        this.setLoadingComments(false);
        this.commentstate.clear();
        this.loadComments();
        this.lastcommenttime = -1;
    }
    deleteEditNote(nid) {
        const req = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            id: nid
        };
        this.setDeletingNote(nid);
        Apphandler.sendMessage("deletenote", req);
    }
    setLoadingComments(loading) {
        this.loadingcomments = loading;
    }
    getAllNotes() {
        if (this.loadingnotes || !this.activerowid
            || !this.activeschema || !this.activelterid || !this.activeuserid) {
            return;
        }
        this.lastnotesupdatetime = -1;
        this.activeloadednotesref = "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid;
        this.setLoadingNotes(true);
        const req = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            referencid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            ischooser: true
        };
        Apphandler.sendMessage("getnotes", req);
        if (this.notestimeout) {
            clearTimeout(this.notestimeout);
        }
    }
    convertNoteToNoteUI(note) {
        const noteui = new DraftNoteUI(note);
        noteui.setNote(note);
        noteui.setVisible(true);
        return noteui;
    }
    clearLinks() {
        this.links.splice(0, this.links.length);
    }
    removeNote(nid) {
        this.notesbyid.delete(nid);
    }
    setAppliedAclString(str) {
        this.appliedaclstr = str;
    }
    selectAccessids(ids) {
        this.activeaccessids.clear();
        for (const id of ids) {
            this.addActiveAccessId(id);
        }
    }
    addActiveAccessId(id) {
        this.activeaccessids.add(id);
    }
    getCommentUpdate() {
        if (this.loadingnotes || !this.activelterid || !this.activedatasheet || !this.activeschema
            || !this.activerowid
            || !this.editnoteid) {
            return;
        }
        const comms = this.commentstate.getComments();
        if (this.lastcommenttime == -1) {
            this.lastcommenttime = new Date().getTime();
        }
        const updatereques = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            since: this.lastcommenttime,
            noteid: this.editnoteid,
            referencid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            updatetype: ObjectUpdateType.Comment
        };
        Apphandler.sendMessage("activeobjectid", updatereques);
    }
    getNotesUpdate() {
        this.getCommentUpdate();
        if (this.loadingnotes || !this.activelterid || !this.activedatasheet || !this.activeschema
            || !this.activerowid) {
            return;
        }
        if (this.lastnotesupdatetime === -1) {
            this.lastnotesupdatetime = new Date().getTime();
        }
        const updatereques = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            referencid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            since: this.lastnotesupdatetime,
            updatetype: ObjectUpdateType.Note
        };
        Apphandler.sendMessage("activeobjectid", updatereques);
        this.notestimeout = setTimeout(() => this.getNotesUpdate(), 10000);
    }
    setStartNotes(start) {
        this.startnotes = start;
    }
    // @action
    // public updateRow(id: string, entry: Entry[]) {
    //     let rindex = -1;
    //     const row = this.rowsMap.get(id);
    //     if (row) {
    //         for (const en of entry) {
    //             let eindex = -1;
    //             for (let i = 0; i < row.entry.length; i++) {
    //                 const ren = row.entry[i];
    //                 if (ren.id === en.id) {
    //                     eindex = i;
    //                 }
    //             }
    //             if (eindex > -1) {
    //                 row.entry.splice(eindex, 1, en);
    //             } else {
    //                 row.entry.push(en);
    //             }
    //         }
    //         for (const en of this.deleteentries) {
    //             let eindex = -1;
    //             for (let i = 0; i < row.entry.length; i++) {
    //                 const ren = row.entry[i];
    //                 if (ren.id === en.id) {
    //                     eindex = i;
    //                 }
    //             }
    //             if (eindex > -1) {
    //                 row.entry.splice(eindex, 1);
    //             }
    //         }
    //         this.addRuleEntryToRow(row);
    //         this.redoRowRule(row);
    //         this.rowsMap.set(id, row);
    //     }
    // }
    setActiveTab(tab) {
        this.activedetailtab = tab;
        if (tab === 'notes' &&
            this.activeloadednotesref !== "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid) {
            this.getAllNotes();
        }
    }
    setShowLinkDialog(show) {
        this.showlinkdialog = show;
    }
    setFilter(filter) {
        for (const n of this.notesbyid.values()) {
            if (n.note !== undefined) {
                if (filter.toDate !== undefined && filter.toDate > 0) {
                    if (n.note.updatetime <= filter.toDate) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.fromDate !== undefined && filter.fromDate > 0) {
                    if (n.note.updatetime >= filter.fromDate - 1) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.toPage !== undefined && filter.toPage > 0) {
                    const parts = n.note.data.match.split(":");
                    if (parts.length > 1) {
                        const stpg = parseInt(parts[1]);
                        if (stpg <= filter.toPage - 1) {
                        }
                        else {
                            n.setVisible(false);
                            continue;
                        }
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.fromPage !== undefined && filter.fromPage > 0) {
                    const parts = n.note.data.match.split(":");
                    if (parts.length > 1) {
                        const stpg = parseInt(parts[1]);
                        if (stpg >= filter.fromPage - 1) {
                        }
                        else {
                            n.setVisible(false);
                            continue;
                        }
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.type != undefined && filter.type.length > 0) {
                    if (filter.type.indexOf(n.note.data.notetype) !== -1) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.authors != undefined && filter.authors.length > 0) {
                    if (filter.authors.indexOf(n.note.authorid) !== -1) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.notetype != undefined && filter.notetype.length > 0) {
                    if (n.note.linkboxes !== undefined && n.note.linkboxes.length > 0 && filter.notetype.indexOf(n.note.type) !== -1) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.notetype != undefined && filter.filterlinknote) {
                    if (n.note.linkboxes === undefined) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                n.setVisible(true);
            }
        }
    }
    setNotesLoading(load) {
        this.schemanotesloading = load;
    }
    // public saveActiveRowEdits() {
    //     if (!this.activeschema) {
    //         return;
    //     }
    //     const achema = this.schemas.get(this.activeschema);
    //     if (!achema) {
    //         return;
    //     }
    //     if (this.editrowproperty.size === 0) {
    //         return;
    //     }
    //     this.setSavingRow(true);
    //     // now lets just save thes evalues and we done hurraty!!
    //     const cellmap: Map<string, SchemaItem> = new Map();
    //     for (const shi of achema.parentschema?.items??[]) {
    //         cellmap.set(shi.id, shi);
    //         const sentry = this.editrowproperty.get(shi.id);
    //         if (shi.required && sentry && !sentry.celldata) {
    //             APPEvent.publishApperror(shi.name + " is  a mandatory field.");
    //             this.setSavingRow(false);
    //             return;
    //         }
    //     }
    //     for (const shi of achema.items) {
    //         cellmap.set(shi.id, shi);
    //         const sentry = this.editrowproperty.get(shi.id);
    //         if (shi.required && sentry && !sentry.celldata) {
    //             APPEvent.publishApperror(shi.name + " is  a mandatory field.");
    //             this.setSavingRow(false);
    //             return;
    //         }
    //     }
    //     const sh = achema;
    //     const sentries: Entry[] = [];
    //     for (const [k, val] of this.editrowproperty) {
    //         const citem = cellmap.get(k);
    //         if (citem) {
    //             if (citem.type === SchemaItemType.Number) {
    //                 let sortstring = -1;
    //                 if (val.celldata.indexOf(".") > -1) {
    //                     sortstring = sh.numberoffset + parseFloat(val.celldata);
    //                 } else {
    //                     sortstring = sh.numberoffset + parseInt(val.celldata);
    //                 }
    //                 val.sortstring = sortstring;
    //             } else if (citem.type === SchemaItemType.Date) {
    //                 if (val.celldata) {
    //                     val.sortstring = sh.dateoffset + parseInt(val.celldata);
    //                 }
    //             }
    //             val.schemaid = this.activeschema;
    //             sentries.push(val);
    //         }
    //     }
    //     let arow = this.rowsMap[this.activerowindex];
    //     let key = sh.accesskey;
    //     let nonce = sh.nonce;
    //     if(arow.entry[0].schemaid !== this.activeschema) {
    //         if(!sh.parentschema) {
    //             return;
    //         }
    //         key = sh.parentschema.accesskey;
    //         nonce = sh.parentschema.nonce;
    //         console.log("using oarent row now");
    //     }
    //     if (sentries.length > 0) {
    //         const reqid = Math.random() + "";
    //         const req: AddEntry = {
    //             letrid: this.activelterid,
    //             sid: this.activeschema,
    //             reqid: reqid,
    //             entries: sentries,
    //             accesskey: key,
    //             nonce: nonce,
    //             rowid: this.activerowid,
    //             duplicaterequest: false,
    //             schemaitems: []
    //         };
    //         this.activereqid = reqid;
    //         Apphandler.sendMessage("updaterow", req);
    //     } else {
    //         this.setSavingRow(false);
    //     }
    // }
    setShowGanttStartDate(show) {
        this.showganttstartdate = show;
    }
    setShowChartMenu(show) {
        this.showchartmenu = show;
    }
    setShowGanttStartDateName(show) {
        this.showganttstartdatename = show;
    }
    setShowGanttEndDateName(show) {
        this.showganttenddatename = show;
    }
    setShowGanttEndDate(show) {
        this.showganttenddate = show;
    }
    setShowColorField(show) {
        this.showcolorfield = show;
    }
    setColorFieldId(id) {
        this.colorfieldid = id;
    }
    setColorFieldName(id) {
        this.colorfieldname = id;
    }
    setActiveRowId(id) {
        this.activerowid = id;
        this.editrowproperty.clear();
        this.setSavingRow(false);
        this.resetNotes();
    }
    removePropertiesFromActiveRow(id) {
        this.editrowproperty.delete(id);
    }
    setPropertiesForActiveRow(id, entry) {
        this.editrowproperty.set(id, entry);
    }
    setShowDescField(show) {
        this.showdescfield = show;
    }
    setDescFieldId(id) {
        this.descfieldid = id;
    }
    setDescFieldName(id) {
        this.descfieldname = id;
    }
    setGanttStartDate(show) {
        this.ganttstartid = show;
    }
    setGanttEndDate(show) {
        this.ganttendid = show;
    }
    setActiveGroupByMenu(show) {
        this.showgroupbymenu = show;
    }
    setShowStatusesMenu(show) {
        this.showstatuesmenu = show;
    }
    setActiveCardStatusName(st) {
        this.activecardstatusname = st;
    }
    setActiveCardGroupName(st) {
        this.activecardgroupname = st;
    }
    setActiveDatasheet(did, load = true) {
        this.reset();
        this.activedatasheet = did;
        if (load) {
            this.setLoading(true);
            this.loadSchemas();
        }
    }
    loadSchemas() {
        const req = {
            letrid: this.activelterid,
            datasheetid: this.activedatasheet,
            userid: this.activeuserid,
            floating: true
        };
        Apphandler.sendMessage("admingetschemas", req);
    }
    decryptCell(fitem) {
        var _a, _b;
        if (fitem.decrypted) {
            return;
        }
        const hasrule = this.checkCellHasRule(fitem);
        if (this.fetchingdepend && hasrule) {
            this.waitingentries.push(fitem); // mark it so we can rebuild this once we ready with data
            return; // we cant do much here yet
        }
        if (hasrule) {
            if (!this.parsingentry.has(fitem.id)) {
                // if we have rule then we should just parse this now!!
                setTimeout(() => {
                    this.parseCellRule(fitem);
                }, 0);
            }
            return;
        }
        if (!this.activeschema) {
            return;
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return;
        }
        if (fitem.celldata.startsWith("pbk---")) {
            if (!achema.schemaintegrationbox) {
                return;
            }
            let pk = "";
            try {
                const dstr = LetrwingCrypto.decryptSecretBox(achema.schemaintegrationbox, achema.accesskey);
                if (dstr) {
                    const djs = JSON.parse(dstr);
                    pk = djs.privatkey;
                }
            }
            catch (ex) { }
            if (fitem.schemaid === ((_a = achema.parentschema) === null || _a === void 0 ? void 0 : _a.id)) {
                pk = achema.parentschema.webformkeys.priavatekey;
            }
            if (!pk) {
                fitem.celldata = '';
                console.log("missing key for rule parsing");
                return;
            }
            try {
                const emsg = fitem.celldata.substring("pbk---".length);
                const jsonstring = LetrwingCrypto.getUTF8FromBase64(emsg);
                const js = JSON.parse(jsonstring);
                const rawdata = LetrwingCrypto.decryptRSABoxRawString(js, { privatkey: pk, publickey: '' });
                fitem.celldata = rawdata !== null && rawdata !== void 0 ? rawdata : '';
                fitem.cellfindstr = rawdata !== null && rawdata !== void 0 ? rawdata : '';
                fitem.decrypted = true;
            }
            catch (ex) {
                console.log(ex);
            }
            return;
        }
        let key = achema.accesskey;
        let nonce = achema.nonce;
        if (fitem.schemaid === ((_b = achema.parentschema) === null || _b === void 0 ? void 0 : _b.id)) {
            key = achema.parentschema.accesskey;
            nonce = achema.parentschema.nonce;
        }
        const val = LetrwingCrypto.decryptBoxWithNonceToStr({ encryptmsg: fitem.celldata, nonce: '', publickey: '' }, key, nonce);
        fitem.celldata = val !== null && val !== void 0 ? val : '';
        if (fitem.cellfindstr) {
            const val = LetrwingCrypto.decryptBoxWithNonceToStr({ encryptmsg: fitem.cellfindstr, nonce: '', publickey: '' }, key, nonce);
            fitem.cellfindstr = val !== null && val !== void 0 ? val : '';
        }
        else {
            fitem.cellfindstr = '';
        }
        //lets also attach display value here!!
        fitem.decrypted = true;
    }
    checkSchemaCellHasRule(cellid) {
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return false;
        }
        if (achema.rules) {
            for (const ar of achema.rules) {
                if (ar.colid === cellid) {
                    return true;
                }
            }
        }
        return false;
    }
    checkRowCellhasRule(rowid, cellid) {
        const rules = this.rowRules.get(this.activeschema + "~~~" + rowid);
        if (rules) {
            for (const ru of rules.data) {
                if (ru.colid === cellid) {
                    return true;
                }
            }
        }
        return this.checkSchemaCellHasRule(cellid);
    }
    checkCellHasRule(fitem) {
        return this.checkRowCellhasRule(fitem.rowid, fitem.cellid);
    }
    getAllFieldsForItem(itemid) {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitems = achema.items.find((ite) => ite.id === itemid);
        if (!sitems) {
            return [];
        }
        return sitems.items;
    }
    getAllNumberFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitems = achema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
        const ret = [];
        for (const field of sitems) {
            if (field.type === SchemaItemType.Number) {
                const fieldtype = field;
                ret.push(fieldtype);
            }
        }
        return ret;
    }
    getAllTextFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitems = achema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
        const ret = [];
        for (const field of sitems) {
            if (field.type === SchemaItemType.Text) {
                const fieldtype = field;
                ret.push(fieldtype);
            }
        }
        return ret;
    }
    getAllColorFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitems = achema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
        const ret = [];
        for (const field of sitems) {
            if (field.type === SchemaItemType.Color) {
                const fieldtype = field;
                ret.push(fieldtype);
            }
        }
        return ret;
    }
    getAllFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitems = achema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
        return sitems;
    }
    getAllDateFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitems = achema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
        const ret = [];
        for (const field of sitems) {
            if (field.type === SchemaItemType.Date) {
                const fieldtype = field;
                ret.push(fieldtype);
            }
        }
        return ret;
    }
    getAllCardViewChoiceFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitems = achema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
        const ret = [];
        for (const field of sitems) {
            if (field.type === SchemaItemType.Choice) {
                const fieldtype = field;
                if (fieldtype.items && fieldtype.items.length > 0) {
                    ret.push(fieldtype);
                }
            }
        }
        return ret;
    }
    setShowActiveView(show) {
        this.showactiveviewmenu = show;
    }
    setBuildingView(building) {
        this.buildingview = building;
    }
    setActiveView(view) {
        this.activeview = view;
    }
    addSchema(sch) {
        this.schemas.set(sch.id, sch);
    }
    setScrollIndex(index) {
        this.sindex = index;
    }
    async addRows(row, clear = true) {
        if (clear) {
            this.rowsMap.clear();
            this.rowsarrids.splice(0, this.rowsarrids.length);
        }
        let index = 0;
        for (const r of row) {
            this.addRow(r);
            if (index > 0 && index % 1000 === 0) {
                await timeout(10);
            }
            index++;
        }
    }
    arrangeListCells(en) {
        // the way to arrange these will be via the 
        var _a;
        en.sort((en1, en2) => {
            var _a, _b;
            const s1 = (_a = en1.subrowindex) !== null && _a !== void 0 ? _a : -1;
            const s2 = (_b = en2.subrowindex) !== null && _b !== void 0 ? _b : -1;
            if (s1 === -1 && s2 === -1) {
                return 0;
            }
            if (s1 === -1) {
                return 1;
            }
            if (s2 === -1) {
                return -1;
            }
            const parts1 = s1.split("----");
            const parts2 = s2.split("----");
            if (parts1[0] === parts2[0]) {
                // if(parts1.length < 2 || parts2.length < 2) {
                //     return -1;
                // }
                return parts1[1].localeCompare(parts2[1]);
            }
            return parseInt(parts1[0]) - parseInt(parts2[0]);
        });
        let trow = [];
        const rows = [];
        for (const e of en) {
            const s1 = (_a = e.subrowindex) !== null && _a !== void 0 ? _a : -1;
            if (s1 !== -1) {
                if (trow.indexOf(s1) === -1) {
                    trow.push(s1);
                }
            }
        }
        return trow;
    }
    addRuleEntryToRow(row) {
        var _a;
        const rulebycellid = new Map();
        const sh = this.schemas.get(this.activeschema);
        if (sh && sh.rules) {
            for (const rule of sh.rules) {
                rulebycellid.set(rule.colid, rule);
            }
        }
        const rowrules = this.rowRules.get(this.activeschema + "~~~" + row.rowid);
        const rowrmap = new Map();
        if (rowrules) {
            for (const r of rowrules.data) {
                rowrmap.set(r.colid, r);
            }
        }
        for (const [k, v] of rulebycellid) {
            if (!rowrmap.has(k)) {
                rowrmap.set(k, v);
            }
        }
        const emap = new Map();
        for (const en of row.entry) {
            const id = en.cellid.split("----");
            if (!emap.has(id[0])) {
                emap.set(id[0], []);
            }
            let colrule = rulebycellid.get(en.cellid);
            if (rowrmap.size > 0) {
                let cr = rowrmap.get(en.cellid);
                if (cr) {
                    colrule = cr;
                }
            }
            if (en.ruleopen) {
                //if this already had it
                en.decrypted = false;
            }
            en.ruleopen = colrule;
            if (en.ruleopen) {
                // new rule 
                en.decrypted = false;
            }
            (_a = emap.get(id[0])) === null || _a === void 0 ? void 0 : _a.push(en);
        }
        // now lets go over all cells needing rule
        for (const [k, v] of rowrmap) {
            if (k.indexOf("----") !== -1) {
                // lets add entry to this as well now!
                const parts = k.split("----");
                const ens = emap.get(parts[0]);
                if (!ens || (ens === null || ens === void 0 ? void 0 : ens.length) === 0)
                    continue;
                // we have subrows lets add entry for each
                const subrows = this.arrangeListCells(ens);
                const entrymap = new Map();
                // now we have these subrows lets see if we can make sense of this now
                for (const en of ens) {
                    if (!en.subrowindex)
                        continue;
                    entrymap.set(en.cellid + "----" + en.subrowindex, en);
                }
                for (const sr of subrows) {
                    const sid = k + "----" + sr;
                    if (!entrymap.has(sid)) {
                        let en = {
                            celldata: '',
                            cellfindstr: '',
                            cellid: k,
                            schemaid: this.activeschema,
                            rowindex: row.rowindex,
                            rowid: row.rowid,
                            subrowindex: sr,
                            id: LetrwingCrypto.getUUID(),
                            sortstring: Math.random(),
                            decrypted: false
                        };
                        const id = en.cellid.split("----");
                        if (!emap.has(id[0])) {
                            emap.set(id[0], []);
                        }
                        let colrule = rulebycellid.get(en.cellid);
                        if (rowrmap.size > 0) {
                            let cr = rowrmap.get(en.cellid);
                            if (cr) {
                                colrule = cr;
                            }
                        }
                        en.ruleopen = colrule;
                        row.entry.push(en);
                    }
                }
            }
            else {
                if (!emap.has(k)) {
                    let en = {
                        celldata: '',
                        cellfindstr: '',
                        cellid: k,
                        schemaid: this.activeschema,
                        rowindex: row.rowindex,
                        rowid: row.rowid,
                        subrowindex: "",
                        id: LetrwingCrypto.getUUID(),
                        sortstring: Math.random(),
                        decrypted: false
                    };
                    const id = en.cellid.split("----");
                    if (!emap.has(id[0])) {
                        emap.set(id[0], []);
                    }
                    let colrule = rulebycellid.get(en.cellid);
                    if (rowrmap.size > 0) {
                        let cr = rowrmap.get(en.cellid);
                        if (cr) {
                            colrule = cr;
                        }
                    }
                    en.ruleopen = colrule;
                    row.entry.push(en);
                }
            }
        }
    }
    addRuleEntryToRows() {
        for (const row of this.rowsMap.values()) {
            this.addRuleEntryToRow(row);
        }
    }
    addRow(row) {
        this.addRuleEntryToRow(row);
        this.rowsMap.set(row.rowid, row);
    }
    addNewRow(nrow) {
        this.newrowsmap.push(nrow);
    }
    removeRow(index) {
        this.rowsMap.delete(index);
    }
    removeNewRow(index) {
        let nrin = -1;
        for (let i = 0; i < this.newrowsmap.length; i++) {
            const nr = this.newrowsmap[i];
            if (nr.rowindex === index) {
                nrin = i;
                break;
            }
        }
        this.newrowsmap.splice(nrin, 1);
    }
    setStoringForm(storing) {
        this.storingform = storing;
    }
    setLoadingContent(loading) {
        this.loadingcontent = loading;
    }
    setLoadmore(loading) {
        this.loadmore = loading;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    loadMoreRows() {
    }
    resetNotes() {
        this.clearShowBookmark();
        this.notesbyid.clear();
        this.showinoutlinks.clear();
        if (this.notestimeout) {
            clearTimeout(this.notestimeout);
        }
        this.setLoadingNotes(false);
        this.setAppliedAclString("");
        this.selectAccessids([ALLViewer]);
        this.setShowComments(false);
        this.commentstate.clear();
    }
    setShowComments(dn) {
        this.showcomments = dn;
    }
    addRowRule(rule) {
        this.rowRules.set(rule.id, rule);
    }
    cleaRowRule() {
        this.rowRules.clear();
    }
    setActiveSchema(id) {
        this.setFeatchingDepende(false);
        this.depschemarows.clear();
        this.cleaRowRule();
        this.loadedentry = 0;
        this.waitingentries = [];
        this.schemadep = undefined;
        this.colwithschemarules.clear();
        this.selectedrows.clear();
        this.resetNotes();
        this.activeschema = id;
        this.setActiveRowId("");
        this.formentry.clear();
        this.setActiveTab('detail');
        this.setActiveView("grid");
        this.activeloadednotesref = "";
        this.notesbyid.clear();
        this.setNotesLoading(false);
        this.setSavingRow(false);
        this.rowsMap.clear();
        this.newrowsmap.splice(0, this.newrowsmap.length);
        let items = [];
        const achema = this.schemas.get(id);
        if (achema === null || achema === void 0 ? void 0 : achema.parentschema) {
            items.push(...achema === null || achema === void 0 ? void 0 : achema.parentschema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex));
        }
        if (achema) {
            items.push(...achema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex));
        }
        this.sortedschemaitems = items;
        this.loadSchemaEntries();
        if ((achema === null || achema === void 0 ? void 0 : achema.parentschema) && achema.parentschema.rules) {
            for (const cr of achema.parentschema.rules) {
                let isvalid = false;
                for (const pr of cr.rule) {
                    for (const rrv of pr.params) {
                        if (rrv.type !== 'schema') {
                            isvalid = true;
                            break;
                        }
                        if (rrv.value && rrv.value.split("~~~").length > 2) {
                            isvalid = true;
                            break;
                        }
                    }
                }
                if (isvalid) {
                    this.colwithschemarules.add(cr.colid);
                }
            }
        }
        if (achema === null || achema === void 0 ? void 0 : achema.rules) {
            // lets go over them now!!
            for (const cr of achema.rules) {
                let isvalid = false;
                for (const pr of cr.rule) {
                    for (const rrv of pr.params) {
                        if (rrv.type !== 'schema') {
                            isvalid = true;
                            break;
                        }
                        if (rrv.value && rrv.value.split("~~~").length > 2) {
                            isvalid = true;
                            break;
                        }
                    }
                }
                if (isvalid) {
                    this.colwithschemarules.add(cr.colid);
                }
            }
        }
    }
    loadSchemaEntries() {
        var _a, _b;
        if (this.loadingcontent || !this.activeschema || !this.activelterid || !this.activeuserid) {
            return;
        }
        const sh = this.schemas.get(this.activeschema);
        if (!sh) {
            return;
        }
        this.setLoadingContent(true);
        const cids = [];
        if (sh.items && sh.items.length > 0) {
            for (let i = 0; i < sh.items.length; i++) {
                const item = sh.items[i];
                cids.push(item.id);
                if (item.type === SchemaItemType.List) {
                    const litem = item;
                    if (litem.items && litem.items.length > 0) {
                        cids.push(...litem.items.map((il) => litem.id + "----" + il.id));
                    }
                }
            }
        }
        if (sh.parentschema && sh.parentschema.items && sh.parentschema.items.length > 0) {
            for (let i = 0; i < sh.parentschema.items.length; i++) {
                const item = sh.parentschema.items[i];
                cids.push(item.id);
                if (item.type === SchemaItemType.List) {
                    const litem = item;
                    if (litem.items && litem.items.length > 0) {
                        cids.push(...litem.items.map((il) => litem.id + "----" + il.id));
                    }
                }
            }
            // we should also add some of the things like 
        }
        if (sh.childrenschema && sh.childrenschema.length > 0) {
            for (const ch of sh.childrenschema) {
                if (ch.items && ch.items.length > 0) {
                    for (let i = 0; i < ch.items.length; i++) {
                        const item = ch.items[i];
                        cids.push(item.id);
                        if (item.type === SchemaItemType.List) {
                            const litem = item;
                            if (litem.items && litem.items.length > 0) {
                                cids.push(...litem.items.map((il) => litem.id + "----" + il.id));
                            }
                        }
                    }
                }
            }
        }
        const req = {
            letrid: this.activelterid,
            schemaid: this.activeschema,
            floating: true,
            dataids: cids,
            privatekey: (_b = (_a = sh.webformkeys) === null || _a === void 0 ? void 0 : _a.priavatekey) !== null && _b !== void 0 ? _b : '',
            schamenonce: sh.nonce,
            schemakey: sh.accesskey,
            sitems: sh.items,
            userid: this.activeuserid,
        };
        Apphandler.sendMessage("admingetrows", req);
    }
    setShowForm(show) {
        this.showform = show;
    }
    addFormEntry(id, val) {
        this.formentry.set(id, val);
    }
    reset() {
        this.loadedentry = 0;
        this.clearRowsel();
        this.resetNotes();
        this.setNotesLoading(false);
        this.setActiveTab('detail');
        this.setActiveRowId("");
        this.activedatasheet = "";
        this.schemas.clear();
        this.setLoading(false);
        this.setActiveSchema("");
        this.setLoadingContent(false);
        this.setActiveView("grid");
        this.showganttenddatename = "Task End Date";
        this.showganttstartdatename = "Task Start Date";
        this.colorfieldname = "Default Colors";
        this.setShowGanttEndDate(false);
        this.setShowGanttStartDate(false);
        this.setGanttEndDate("");
        this.setGanttStartDate("");
        this.formentry.clear();
        this.rowsMap.clear();
        this.newrowsmap.splice(0, this.newrowsmap.length);
        this.setObjectViewerMode(false);
        // this.getAnalytics();
        this.dependentdata.clear();
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "width", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "left", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "top", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "dragging", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "title", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "linkingmode", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminFloatingDatasheetStore.prototype, "schemas", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "activeschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "loadingcontent", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "showform", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "storingform", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminFloatingDatasheetStore.prototype, "formentry", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AdminFloatingDatasheetStore.prototype, "newrowsmap", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "buildingview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "showlinkdialog", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "showactiveviewmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "activeview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "showstatuesmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "loadmore", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "activecardsttaus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "activecardgroupby", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "activecardstatusname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "activecardgroupname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "startnotes", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "showgroupbymenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "showganttstartdate", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "showganttstartdatename", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "showganttenddatename", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "colorfieldname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "colorfieldid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "showcolorfield", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "showchartmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AdminFloatingDatasheetStore.prototype, "links", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminFloatingDatasheetStore.prototype, "selectedrows", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "schemanotesloading", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminFloatingDatasheetStore.prototype, "deletenoteids", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "shownotespanel", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "sindex", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "descfieldname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "descfieldid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "showdescfield", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminFloatingDatasheetStore.prototype, "activedetailtab", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "loadingcomments", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "deletingnote", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "enableannotation", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "showfilter", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminFloatingDatasheetStore.prototype, "showbookmarklinkdetail", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminFloatingDatasheetStore.prototype, "notesbyid", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminFloatingDatasheetStore.prototype, "activeaccessids", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminFloatingDatasheetStore.prototype, "appliedaclstr", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "editnoteid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "editmode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "showcomments", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "loadingnotes", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminFloatingDatasheetStore.prototype, "authors", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "showganttenddate", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "ganttstartid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "ganttendid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "ganttasknameid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "ganttasknamefieldname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "activerowid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "savingrow", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "savingnote", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminFloatingDatasheetStore.prototype, "editrowproperty", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "notelinksdialogleft", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "notelinksdialogtop", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminFloatingDatasheetStore.prototype, "showinoutlinks", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "objectviewer", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "checkingandcollecting", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminFloatingDatasheetStore.prototype, "rowRules", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "fetchingdepend", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminFloatingDatasheetStore.prototype, "parsingentry", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "gettinganas", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminFloatingDatasheetStore.prototype, "anas", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminFloatingDatasheetStore.prototype, "anasschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminFloatingDatasheetStore.prototype, "colwithschemarules", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "loadedentry", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminFloatingDatasheetStore.prototype, "hiddenrows", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "showrowsilter", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingDatasheetStore.prototype, "showcolumnview", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminFloatingDatasheetStore.prototype, "hiddencolumns", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setLoadedRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Boolean]),
    __metadata("design:returntype", Promise)
], AdminFloatingDatasheetStore.prototype, "addRowInline", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "clearAns", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setGettingAns", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "parseCellRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "removeIdfromParsing", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "collectRowsAndBuildRulesResult", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setFeatchingDepende", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setCollectingData", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setObjectViewerMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setGanttTaskField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setGanttTaskFieldName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setSavingRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "addRowSel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setLinkingMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "removeRowSel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "clearRowsel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setAuthor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "removeDeletingNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setTop", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setWidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "removeShowBookmarkDetail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setShowBookmark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "clearShowBookmark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setEnableAnnotation", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "deleteLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setNoteLinksDialogLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setNoteLinksDialogTop", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setShowDialog", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setShowLinksForNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "clearShowLinksForNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "removeShowLinksForNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setLoadingNotes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setShowNotesPanel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "addNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setDeletingNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setEditMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setSavingNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setEditNoteId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setLoadingComments", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "clearLinks", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "removeNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setAppliedAclString", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "selectAccessids", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "addActiveAccessId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setStartNotes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setActiveTab", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setShowLinkDialog", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setNotesLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setShowGanttStartDate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setShowChartMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setShowGanttStartDateName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setShowGanttEndDateName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setShowGanttEndDate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setShowColorField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setColorFieldId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setColorFieldName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setActiveRowId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "removePropertiesFromActiveRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setPropertiesForActiveRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setShowDescField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setDescFieldId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setDescFieldName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setGanttStartDate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setGanttEndDate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setActiveGroupByMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setShowStatusesMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setActiveCardStatusName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setActiveCardGroupName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "decryptCell", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setShowActiveView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setBuildingView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setActiveView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "addSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setScrollIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Boolean]),
    __metadata("design:returntype", Promise)
], AdminFloatingDatasheetStore.prototype, "addRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "addRuleEntryToRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "addRuleEntryToRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "addRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "addNewRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "removeRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "removeNewRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setStoringForm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setLoadingContent", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setLoadmore", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "resetNotes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setShowComments", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "addRowRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "cleaRowRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setActiveSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "setShowForm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "addFormEntry", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminFloatingDatasheetStore.prototype, "reset", null);
